/** Central auth persistence for local vs session storage */

export const TOKEN_KEY = "token";
export const USER_KEY = "user";
export const KEEP_SIGNED_IN_KEY = "keepSignedIn";

export function getAuthToken() {
  if (typeof window === "undefined") return null;
  return (
    localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || null
  );
}

/** Raw JSON string of stored user, or null */
export function getAuthUserJson() {
  if (typeof window === "undefined") return null;
  const keep = localStorage.getItem(KEEP_SIGNED_IN_KEY);
  if (keep === "true") {
    return localStorage.getItem(USER_KEY);
  }
  if (keep === "false") {
    return (
      sessionStorage.getItem(USER_KEY) || localStorage.getItem(USER_KEY)
    );
  }
  return (
    localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY)
  );
}

export function parseStoredUser() {
  try {
    const raw = getAuthUserJson();
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Remove auth keys from both storages (does not clear unrelated localStorage) */
export function clearAuthStorage() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(KEEP_SIGNED_IN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
}

/**
 * @param {object} opts
 * @param {string} opts.token JWT
 * @param {object} opts.user Serializable user (subset is fine)
 * @param {boolean} opts.keepSignedIn If true → localStorage; else → sessionStorage only
 */
export function persistAuthSession({ token, user, keepSignedIn }) {
  clearAuthStorage();
  const userJson = JSON.stringify(user);
  if (keepSignedIn) {
    localStorage.setItem(KEEP_SIGNED_IN_KEY, "true");
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, userJson);
  } else {
    localStorage.setItem(KEEP_SIGNED_IN_KEY, "false");
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(USER_KEY, userJson);
  }
}
